/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/prop-types */
import React, { Fragment } from "react";
import Divider from '@material-ui/core/Divider';
import { withStyles } from "@material-ui/styles";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";

import LoginMenu from '../../../../components/LoginMenu/LoginMenu';

import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import UploadDocumentsTable from './UploadDocumentsTable';


function isEmpty(obj) {

  if (obj == null) return true;

  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  if (typeof obj !== "object") return true;

  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

const useStyles = (theme) => ({
  downShift: {
    paddingTop: "18px !important",
  },
  textFieldCard: {
    paddingTop: "0px !important",
  },
  cardcontent: {
    paddingTop: "0px !important",
    paddingLeft: "4px",
    paddingRight: "4px",
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
    fontSize: "2px !important",
    padding: "8px !important",
  },
  asdf: {
    margin: 1000,
  },
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,

    marginRight: 20,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  bigAvatar: {
    margin: 10,
  },
  badgeMargin: {
    margin: theme.spacing.unit * 2,
  },
  inline: {
    display: "inline",
  },
  card: {
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "10px",
  },
  formControl: {
    minWidth: "100%",

  },
  container: {
    marginTop: "100px",
  },
});


function MyDropzone(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map((file, index) => {
    const size = file.size > 0 ? (file.size / 1000).toFixed(2) : file.size;
    return (
      <Typography key={index} variant="subtitle1" color="primary">
        {file.path} - {size} Kb
        <input type="hidden" name="file_name" value={file.path}></input>
      </Typography>
    )
  });

  let msg = files || [];
  if (msg.length <= 0 || props.files.length <= 0) {
    msg = <Typography variant="subtitle1">
      Please click to select a file or drop your file here
  </Typography>;
  }
  return (
    <div
      style={{ textAlign: "center" }}
      {...getRootProps({ className: "dropzone", onChange: event => props.onChange(event) })}
    >
      <Card style={{ backgroundColor: "#c7c7c7" }}>
        <CardContent style={{
          paddingBottom: 18
        }}>
          <input name="contained-button-file" {...getInputProps()} disabled={props.disabled} />
          {msg}

        </CardContent>
      </Card>
    </div>
  );
}
class UploadDocumentsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      documentData: [],
      documentList: [],

      documentTypeId: "",
      documentTypeIdError: "",
      otherDocumentTypeLabel: "",
      otherDocumentTypeLabelError: "",
      files: [],
      filesError: "",

      isLoading: false,
      isUploading: false,
      isLoginMenu: false,
      isReload: false,
      loadingCheck: false,
      isNotUploaded: false,
      firstMsg: "",
      uploadMsg: "",
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({
      isLoading: true
    })
    await this.getDocumentListData();
    await this.getData();

    this.setState({
      isLoading: false
    })
  };

  getData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          if (result.CODE === 1) {
            this.setState({
              documentData: result.DATA || []
            })
          } else {
            alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE)
          }
        },
        (error) => {
          alert("Operation Failed, Please try again later");
          console.log(error);
        }
      );
  };

  getDocumentListData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationRequiredDocumentListView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.setState({
              documentList: json.DATA || [],
            });
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: true
          })
        } else {
          alert('Operation Failed, Please try again later.');
        }
        console.log(error);
      });
  }

  isFormValid = () => {
    let { documentTypeIdError, otherDocumentTypeLabelError, filesError } = this.state;
    let isValid = true;
    if (!this.state.documentTypeId) {
      isValid = false
      documentTypeIdError = "Please select document type.";
    }
    if (this.state.documentTypeId == 6) {
      if (!this.state.otherDocumentTypeLabel) {
        isValid = false;
        otherDocumentTypeLabelError = "Please enter description.";
      }
    }
    if (this.state.files.length <= 0) {
      isValid = false;
      filesError = "Please select a file."
    }
    this.setState({
      otherDocumentTypeLabelError,
      filesError,
      documentTypeIdError
    })
    return isValid;
  }

  handleSubmitButtonClick = () => {
    const isValid = this.isFormValid();
    if (isValid) {
      document.getElementById("submit-button").click();
    }
    return;
  };

  handleSubmit = async (e) => {

    e.preventDefault();
    const data = new FormData(e.target);
    this.setState({
      isUploading: true,
    });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsUpload`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then((result) => {
        if (result.CODE == 1) {
          this.setState({
            files: [],
            filesError: "",
            documentTypeId: "",
            documentTypeIdError: "",
            otherDocumentTypeLabel: "",
            otherDocumentTypeLabelError: ""
          })
          this.loadData();
        } else {
          alert(result.CODE + ":" + result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
    this.setState({
      isUploading: false,
    });
  };

  DownloadFile = (fileName) => {
    const data = new FormData();
    data.append("fileName", fileName);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${
      process.env.REACT_APP_SUB_API_NAME
      }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;

    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
          return {}
        } else {
          alert('Operation Failed, Please try again later.');
          return {}
        }
      })
      .then((result) => {
        var csvURL = window.URL.createObjectURL(result);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        console.log(csvURL);
        if (result.CODE == 1) {
          //Code
        } else if (result.CODE == 2) {
          alert(
            "SQL Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.CODE == 3) {
          alert(
            "Other Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.error == 1) {
          alert(result.error_message);
        } else if (result.success == 0 && result.redirect_url != "") {
          window.location = result.redirect_url;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleFileChange = event => {
    const { files = [] } = event.target;
    console.log(files);
    this.setState({
      files,
      filesError: ""
    })

  }

  getCheck = async () => {
    let documentsData = [];
    let documentsList = [];
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsView`;
    this.setState({
      loadingCheck: true
    })
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken")
      })
    })
      .then(res => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        async json => {
          if (json.DATA) {
            documentsData = json.DATA || [];
            this.setState({
              documentsData
            })
            if (localStorage.getItem("isSubmitted") != 1) {
              const urlList = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationRequiredDocumentListView`;
              await fetch(urlList, {
                method: "GET",
                headers: new Headers({
                  Authorization: "Bearer " + localStorage.getItem("uclToken")
                })
              })
                .then(res => {
                  if (!res.ok) {
                    throw res;
                  }
                  return res.json();
                })
                .then(
                  json => {
                    if (json.DATA) {
                      documentsList = json.DATA || [];
                    }
                  },
                  error => {
                    console.log(error);
                  });
              let { isNotUploaded, uploadMsg, firstMsg } = this.state;
              let label = "";
              if (documentsData.length <= 0) {
                isNotUploaded = true;
                uploadMsg = '';
                firstMsg = 'Please scan and upload your supporting documents in Document Upload section';
              } else {
                firstMsg = 'Please scan and upload following documents in Document Upload section';
                const pass = documentsData.find(item => item.documentTypeId === 1);
                const cnic = documentsData.find(item => item.documentTypeId === 2);
                const olevel = documentsData.find(item => item.documentTypeId === 9);
                // const alevel = documentsData.find(item => item.documentTypeId === 5);

                if (isEmpty(pass)) {
                  label = documentsList.find(d => d.ID === 1).Label || '';
                  uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                  isNotUploaded = true;
                }
                if (isEmpty(cnic)) {
                  label = documentsList.find(d => d.ID === 2).Label || '';
                  uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                  isNotUploaded = true;
                }
                if (documentsData[0].degreeId === 32) {
                  if (isEmpty(olevel)) {
                    label = documentsList.find(d => d.ID === 9).Label || '';
                    uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                    isNotUploaded = true;
                  }
                }
                if ((documentsData[0].degreeId >= 2 && documentsData[0].degreeId <= 9) || documentsData[0].degreeId === 13 || documentsData[0].degreeId === 14) {
                  if (isEmpty(olevel)) {
                    label = documentsList.find(d => d.ID === 9).Label || '';
                    uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                    isNotUploaded = true;
                  }
                  // if (isEmpty(alevel)) {
                  //   label = documentsList.find(d => d.ID === 5).Label || '';
                  //   uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                  //   isNotUploaded = true;
                  // }
                }
                if (!isNotUploaded) {
                  window.location.replace('#/dashboard/review');
                }
              }

              this.setState({
                isNotUploaded,
                uploadMsg,
                firstMsg
              })
            }
          }
        },
        error => {
          if (error.status == 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true
            })
          } else {
            alert('Failed to fetch, Please try again later.');
            console.log(error);
          }
        });
    this.setState({
      loadingCheck: false,
    })
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    this.setState({
      [name]: value,
      [errName]: ""
    })
  }

  deleteFile = (id) => {
    const data = new FormData();
    data.append("documentTypeId", id);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsDelete`;
    fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          console.log(result);
          if (result["CODE"] == 1) {
            this.loadData();
          } else {
            alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
          }
        })
      .catch((error) => {
        if (error.status == 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false
          })
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
  };

  render() {
    const { classes } = this.props;
    const isSaved = localStorage.getItem("isSaved");

    return (
      <Fragment>
        <LoginMenu reload={this.state.isReload} open={this.state.isLoginMenu} handleClose={() => this.setState({ isLoginMenu: false })} />
        <div className={classes.root}>

          <Dialog
            open={this.state.isNotUploaded}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Incomplete Documents"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.firstMsg}
                <div> <strong>{this.state.uploadMsg}</strong> </div>

              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="primary"
                variant="outlined"
                style={{
                  marginBottom: 10,
                  marginRight: 10,
                  awidth: 150,
                  textTransform: "capitalize",
                  color: "#303F9F",
                  borderColor: "#303F9F",
                }}
                disabled={this.state.loadingData}
                onClick={() => this.setState({
                  isNotUploaded: false,
                  uploadMsg: "",
                  firstMsg: ""
                })}
              >
                Close
                        </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={isSaved == 0}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Application Not Found"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Please complete and submit your admission application. You would be able to upload supporting documents after submission of your admission application.
            </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="primary"
                variant="outlined"
                style={{
                  marginBottom: 10,
                  marginRight: 10,
                  awidth: 150,
                  textTransform: "capitalize",
                  color: "#303F9F",
                  borderColor: "#303F9F",
                }}
                disabled={this.state.loadingData}
              >
                <Link style={{ textDecoration: 'none' }} to='/dashboard/admission-application'>
                  Go to Admission Application
                          </Link>

              </Button>
            </DialogActions>
          </Dialog>
          <div
            style={{
              marginTop: "15px",
              marginBottom: "60px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "96%" }}>
              <form
                id="myform"
                onSubmit={this.handleSubmit}
                autoComplete="off"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <div style={{ padding: 10 }}>
                      <Typography
                        style={{
                          color: "#1d5f98",
                          fontWeight: 600,
                          fontSize: 20,
                        }}
                        variant="h5"
                      >
                        Upload Documents
                    </Typography>
                      <Divider />
                      <br></br>
                      <Typography
                        style={{ fontSize: 14, paddingTop: "20px" }}
                        variant="p"
                      > Please upload all the required documents here and click “Next” to proceed to the next step.

                      </Typography>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20 }}
                  >
                    <TextField
                      name="documentTypeId"
                      fullWidth
                      label="Document Type"
                      value={this.state.documentTypeId}
                      onChange={this.handleChange}
                      error={this.state.documentTypeIdError}
                      required
                      select
                    >
                      {this.state.documentList.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.ID}>
                            {item.Label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <div>&nbsp;</div>
                  </Grid>
                  {this.state.documentTypeId == 6 && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      style={{
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 10,
                        marginTop: '-10px',
                        marginBottom: 20
                      }}
                    >
                      <TextField
                        id="otherDocumentTypeLabel"
                        name="otherDocumentTypeLabel"
                        label="Description"
                        onChange={this.handleChange}
                        error={this.state.otherDocumentTypeLabelError}
                        value={this.state.otherDocumentTypeLabel}
                        fullWidth
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={11}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                  >

                    <MyDropzone files={this.state.files} onChange={event => this.handleFileChange(event)} disabled={this.state.isUploading} />
                    <div style={{
                      textAlign: 'center',
                      marginTop: 10
                    }}>
                      <span style={{
                        color: '#ff2d2d'
                      }}>{this.state.filesError}</span>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={1}
                    style={{
                      paddingTop: 10,
                      marginTop: 10,
                    }}
                  >
                    <input
                      id="submit-button"
                      type="submit"
                      style={{ display: "none" }}
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      style={{ width: 75, height: 40 }}
                      onClick={() => this.handleSubmitButtonClick()}
                      disabled={this.state.isUploading}
                    >
                      {this.state.isUploading ? (
                        <CircularProgress style={{ color: "white" }} size={24} />
                      ) : (
                          "Upload"
                        )}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                  >
                    <UploadDocumentsTable rows={this.state.documentData}
                      columns={[
                        { key: "documentTypeLabel", label: "Document Type", style: { width: '30%' } },
                        { key: "otherDocumentTypeLabel", label: "Description", style: { width: '30%' } },
                        { key: "uploadedOn", label: "Upload Date", style: { width: '20%' } }
                      ]} onDownload={name => this.DownloadFile(name)} onDelete={id => this.deleteFile(id)} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 20 }}
                  >
                    <Typography
                      style={{ color: "#1d5f98", fontWeight: 600, fontSize: 16, fontStyle: 'italic' }}
                      variant="h5"
                    >
                      Reference Letter (not applicable to Bloomfield Hall School
                      or UCL students)
                  </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 0 }}
                  >
                    <Typography style={{ fontSize: 14, paddingTop: "20px" }} variant="p">
                      Please ask your referee to email us your reference letter at <a href="mailto:admissions@ucl.edu.pk">admissions@ucl.edu.pk</a><b> within 5 working days</b> of submission of your admission application. Your Full Name, Applicant ID and the Programme you Applied for should be mentioned in the email.
                </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{
                      paddingLeft: 20, paddingRight: 20, paddingTop: 20, display: 'flex',
                      justifyContent: 'flex-end'
                    }}
                  >
                    <Button onClick={() => this.getCheck()} color="primary" variant="contained">
                      {(this.state.loadingData || this.state.loadingCheck) ? <CircularProgress style={{ color: 'white' }} size={24} /> : 'Next'}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default withStyles(useStyles)(UploadDocumentsForm);
